import i18n from "@/shared/i18n";
import {store} from "@/plugins/vuex";
import {DPV_LOTS_TABLE_NAME} from "../../constants";
import DpvService from "../DpvService";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: 'lot_title',
    dpvUuid: null,
    expand: 'dpv',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['dpv_no'],
      defaultFields: ['dpv_no', 'sale_number', 'lot_number', 'receipt_number', 'stock_number', 'lot_title',
        'hammer_price', 'buyer_number', 'buyer_full_name', 'invoice_number', 'credit_note_number', 'seller_number',
        'seller_full_name', 'settlement_number', 'debit_note_number'],
    }
  }
};

let getDefaultFields = () => {
  return [
    {
      key: 'dpv_no',
      label: i18n.t('DPV Number'),
      sortable: true,
      isVisible: true
    },
    {
      key: 'sale_number',
      label: i18n.t('Sale'),
      isVisible: true
    },
    {
      key: 'lot_number',
      label: i18n.t('Lot'),
      isVisible: true
    },
    {
      key: 'receipt_number',
      label: i18n.t('Receipt'),
      isVisible: true
    },
    {
      key: 'stock_number',
      label: i18n.t('Receipt / Item'),
      isVisible: true
    },
    {
      key: 'lot_title',
      label: i18n.t('Title'),
      tdClass: 'dpv-details-title-col',
      isVisible: true
    },
    {
      key: 'hammer_price',
      label: i18n.t('Hammer Price'),
      isVisible: true
    },
    {
      key: 'buyer_number',
      label: i18n.t('Buyer Number'),
      isVisible: true
    },
    {
      key: 'buyer_full_name',
      label: i18n.t('Buyer'),
      isVisible: true
    },
    {
      key: 'invoice_number',
      label: i18n.t('Invoice'),
      isVisible: true
    },
    {
      key: 'credit_note_number',
      label: i18n.t('Associated Credit Note'),
      isVisible: true
    },
    {
      key: 'seller_number',
      label: i18n.t('Vendor Number'),
      isVisible: true
    },
    {
      key: 'seller_full_name',
      label: i18n.t('Vendor'),
      isVisible: true
    },
    {
      key: 'settlement_number',
      label: i18n.t('Settlement'),
      isVisible: true
    },
    {
      key: 'debit_note_number',
      label: i18n.t('Associated Debit Note'),
      isVisible: true
    }
  ];
};

export default {
  namespaced: true,
  state: {
    tableData: getDefaultTableData()
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData.pagination.page = 1;
    },
    async getTableData({commit, state, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await DpvService.getDpvLots(state.tableData.dpvUuid, params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering
        });
      }

      return response;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let tableData = state.tableData;
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: tableData,
        tableName: DPV_LOTS_TABLE_NAME
      });

      if (payload) {
        data = {
          ...payload.pagination,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...tableData.pagination,
          ordering: ordering,
        }
      }

      data.expand = tableData.expand;

      return data;
    },
    async updateDpvUuid({commit}, dpvUuid) {
      commit('updateTableData', {'dpvUuid': dpvUuid});
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    }
  },
  mutations: {
    updateTableData: (state, payload) => state.tableData = {...state.tableData, ...payload},
    updateTableLoading: (state, payload) => state.tableData.loading = payload,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData.toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData.toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData.toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData.toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    }
  }
}
